<template>
  <div id="layout-body">
    <div class="body-main">
      <router-view></router-view>
    </div>
    <back-top></back-top>
    <login-dialog></login-dialog>
  </div>
</template>

<script>
import backTop from '@/components/back-top'
import loginDialog from '@/components/dialog/login-dialog'

export default {
  name: "layout-body",
  data() {
    return {}
  },
  components: {
    backTop,
    loginDialog
  }
}
</script>

<style scoped lang="less">
#layout-body {
  margin-top: 70px;
  min-height: -moz-calc(100vh - 70px);
  min-height: -webkit-calc(100vh - 70px);
  min-height: calc(100vh - 70px);
  /*background-color: #eee;*/
  background-image: linear-gradient(to bottom right, #e6a23c26, #eee, #409eff2b);

  /* 水平垂直居中 */
  display: flex;
  justify-content: center;
}

.body-main {
  width: 75%;
}
</style>
